import React from 'react';
import PropTypes from 'prop-types';
import { SettingsDropdown } from '../SettingsDropdown';
import { NotificationCenter } from '../NotificationCenter';
import styles from './PersonalBar.css';
export const PersonalBar = ({ helpLink }) => {
    return (React.createElement("div", { className: styles.bar },
        React.createElement(NotificationCenter, null),
        React.createElement(SettingsDropdown, { helpLink: helpLink })));
};
PersonalBar.propTypes = {
    helpLink: PropTypes.string,
};
//# sourceMappingURL=PersonalBar.js.map